import { useContext } from 'react';
import { StorageProviderContext } from './StorageProviderContext';

export const useStorageProvider = () => {
  const { storageProvider } = useContext(StorageProviderContext);
  return storageProvider;
};
